import React from "react"
import StaticSelector from "components/Atoms/StaticSelector"
import { withFormController } from "components/Molecules/FormController"

const PickupLocations = ({ source, distributionCenter }) => {
  const pickupSlots = source?.pickupSlots
  const timeSlots = distributionCenter?.pickupSlots ?? []

  return (
    <>
      <h6 className="mt-6">Pickup Timeslot</h6>
      <hr className="mt-0" />

      {pickupSlots?.map((_, idx) => {
        const path = `pickupSlots.${idx}`
        return (
          <div key={idx} className="grid grid-cols-12 gap-4">
            <div className="col-span-3">
              <StaticSelector items={timeSlots} path={`${path}.timeSlot`} />
            </div>
          </div>
        )
      })}
    </>
  )
}

export default withFormController(PickupLocations)
